module.exports = __webpack_public_path__ + "static/media/edit.edf36162.svg";